/**
 * Store sub context for config data
 */
import {
  Facility,
  IFacility,
  EmpDepartment,
  IUnitWithDisplayName,
  Unit
} from '../../config/interfaces';

const ConfigContext = {
  apiVersion: '',
  units: [] as Unit[],
  selectedUnits: [] as IUnitWithDisplayName[],
  empDepartments: [] as EmpDepartment[],
  selectedEmpDepartments: [] as EmpDepartment[],
  isAllUnitsChecked: false,
  isFavUnitsChecked: false,
  unitsSelected: false,
  tokenExpiry: '',
  facilities: [] as Facility[],
  userAccessibleFacilities: [] as IFacility[]
};

export default ConfigContext;
